/* eslint-disable import/prefer-default-export */

export const ERROR_MESSAGE = 'Something went wrong, please try again';

export const DATE_FORMATS = {
  DATE_TIME: 'dddd, MMMM Do YYYY, h:mm:ss a',
  DATE_TIME_FULL: 'YYYY-MM-DD HH:mm:ss',
  DATE_ONLY: 'YYYY-MM-DD',
};

export const MODEL_LIST = [
  { name: 'G3-24PEM' },
  { name: '4PTL0/A' },
  { name: '8PTL0/A' },
  { name: '8P3D0/A' },
  { name: '4PTLP/A' },
  { name: '8PTLP/A' },
  { name: '4P3D0/A' },
  { name: '6P3D0/A' },
  { name: '4PTL0/A' },
  { name: '6PTL0/A' },
  { name: '4PTL0/A2M' },
  { name: '8PTL0/A2M' },
  { name: '8PTLP/A2M' },
  { name: '6PTLO/A' },
  { name: 'G3-4PTM10' },
  { name: 'G3-4PTM11' },
  { name: 'G3-4PTM12' },
  { name: 'G3-4PTM20' },
  { name: 'G3-4PTM21' },
  { name: 'G3-4PTM22' },
  { name: 'G3-8PTM10' },
  { name: 'G3-8PTM11' },
  { name: 'G3-8PTM12' },
  { name: 'G3-8PTM20' },
  { name: 'G3-8PTM21' },
  { name: 'G3-8PTM22' },
  { name: '2PTL0/A' },
  { name: 'G3-4S10-A2' },
  { name: 'G3-4S20-A2' },
  { name: 'G3-4S20-A3' },
  { name: 'G3-2S20-A3' },
  { name: 'G3-2S20-A4.4' },
  { name: 'G3-4S20-A4.4' },
  { name: 'G3-4S20-A4.2' },
  { name: 'G3-2S10-A2' },
  { name: 'G3-2S20-A2' },
  { name: 'G3-2S20-A4.2' },
  { name: 'G3-8S20-A4.2' },
  { name: 'G3-8S10-A4.2' },
  { name: 'G3-4S10-A4.2' },
  { name: 'G3-8S20-A3' },
  { name: 'G4-4100' },
  { name: 'Special Box' },
];

export const MODEM_LIST = [{ name: 'Nimbelink' }, { name: 'Quectel' }, { name: 'legacy' }];

export const FIRM_TYPES = [
  { label: 'Standard', value: 'wd-v2' },
  { label: 'Unified', value: 'wd-v3' },
];

export const COMPANY_TYPE_DROPDOWN = [
  { label: 'Retail', value: 'retail' },
  { label: 'Agency', value: 'agency' },
  { label: 'Reseller', value: 'reseller' },
  { label: 'Partner Retail', value: 'partner' },
  { label: 'Manufacturer', value: 'manufacturer' },
];

export const VMAIL_ROUTE = { gateway: 'my.epik.io:5080', route: '1484' };

export const NUMBER_TYPES = [
  { label: 'Alarm', value: 'alarm', active: true },
  { label: 'Dialout', value: 'dialout', active: true },
  { label: 'Secure Entry', value: 'secureEntry', active: true },
  { label: 'Elevator', value: 'elevator', active: true },
  { label: 'Fax - Standard (T.38)', value: 'faxStandard', active: true },
  { label: 'Fire Alarm', value: 'fireAlarm', active: true },
  { label: 'Hunt', value: 'hunt', active: true },
  { label: 'Modem', value: 'modem', active: true },
  { label: 'Page', value: 'page', active: true },
  { label: 'Ring Down', value: 'ringDown', active: true },
  { label: 'Unassigned', value: 'unassigned', active: true },
  { label: 'Voice', value: 'voice', active: true },
  { label: 'Custom', value: 'custom', active: true },
  { label: 'Fax Relay Protocol (T.37)', value: 'fax', active: true },
];
export const NUMBER_TYPES_LABEL = {
  alarm: 'Alarm',
  dialout: 'Dialout',
  secureEntry: 'Secure Entry',
  elevator: 'Elevator',
  faxStandard: 'Fax - Standard (T.38)',
  fireAlarm: 'Fire Alarm',
  hunt: 'Hunt',
  modem: 'Modem',
  page: 'Page',
  ringDown: 'Ring Down',
  unassigned: 'Unassigned',
  voice: 'Voice',
  custom: 'Custom',
  fax: 'Fax Relay Protocol (T.37)',
  vmail: 'Voice Mail',
  forward: 'Forward',
};

export const VMAIL_PROPERTY = { label: 'Voice Mail', value: 'vmail', active: true };

export const FORWARD_PROPERTY = { label: 'Forward', value: 'forward' };

export const PHONE_NUMBER_TYPES = [
  { label: 'Unassigned', value: 'unassigned' },
  { label: 'Ring Group', value: 'ringGroup' },
  { label: 'Voice', value: 'voice' },
  { label: 'Hunt', value: 'hunt' },
];

export const SWITCH_HEADERS = [
  'Device Online',
  'Registered',
  'Register Config Created',
  'EPI MACS Discovered',
  'Edge Device Online',
];
export const SWITCH_MAC_ADDRESS_ARRAY = [
  '250',
  '251',
  '252',
  '253',
  '230',
  '231',
  '232',
  '233',
  '234',
  '235',
  '236',
  '237',
  '238',
  '239',
  '240',
  '241',
];

export const ENG_LOCALE = {
  // Options.jsx
  items_per_page: 'Article / Page',
  jump_to: 'Skip to',
  jump_to_confirm: 'Sure',
  page: 'Page',

  // Pagination.jsx
  prev_page: 'Previous Page',
  next_page: 'Next Page',
  prev_5: 'Back 5 Pages',
  next_5: '5 Pages Forward',
  prev_3: 'Back 3 Pages',
  next_3: '3 Pages Forward',
  page_size: 'Page Number',
};

export const E911ModalType = {
  BOX: 'box',
  SIP: 'sip',
  PRI: 'pri',
};

export const ESysInfoAction = {
  OLD: 'monitor',
  NEW: 'sysInfo',
};

export const DATA_LATENCY_TYPE = {
  GET_LATENCY: 'getLatency',
  UPDATE_LATENCY: 'updateLatency',
};

export const TOOLTIPS_TEXT = {
  RESET_BOX_TO_DEFAULT: 'Resets all options and ports of the epikbox',
  ENABLE_EXP_MODULE:
    'Enables daisy chain for a secondary EPIK Device. NOTE: This function is no longer supported for new deployments.',
  ENABLE_ADVANCED_ROUTING:
    'Configures all call traffic to route through an enhanced routing protocol for this device.',
  ENABLE_ENH_FAX: 'Empty for now',
  ADV_MONITORING:
    'Turns on Advanced monitoring diagnostics if Device Monitoring is enabled. WARNING: Do no enable Advanced Monitoring without prior authorization from Tier 3 support. Advanced Monitoring could cause high bandwidth utilization if running on 4G LTE.',
  PORT_ALERT:
    'Sends port level alerts if a specific port goes into an error state. Must also enable Monitoring under the specific ports to have alerting turned on.',
  OFFLINE_PROV:
    'Allows the EPIK Edge Device to Automaically download updated Port provisioning when it comes online. DO NOT ENABLE IF DEVICE HAS CUSTOM SETTINGS',
  MONITORING: 'Enables Device Monitoring which will trigger alerts for offline devices.',
  SECONDARY_TUNNEL: 'Routes ATA`s Internet Traffic through the Epik Edge to bypass local firewalls',
  STAR_CODES:
    'Enables Star Code Features on the EPIK Edge Device (Example: Last number call forwarding using *70)',
    BOX_OFFLINE_CALL_FORWARD:'Enables Box offline Call Forward',
    
  SIM_PRIOR: 'Established which SIM position should be the default 4G service carrier',
  ACTIVE_SIM: 'Displays which SIM card is Active (SIM 1 or SIM 2)',
  INTERFACE_PRIOR: 'Allows the user to select which interface should act as the default connection',
  CURRENT_APN: 'Displays the current APN to which the 4G LTE network is registered',
  APN: 'Allows the user to update or edit APN settings',
  ENABLE_CALL_RECOR: 'Enables call recording for 24 hours on ports set as Alarm, Fire, & Modem. ',
  EPIK_PROV:
    'Enables the ATA to register to the EPIK provisioning services rather than third part provisioning',
  ENABLE_SIP:
    'Turns on SIP and PRI support in the MyEPIK Portal. Only to be used for PRI or SIP enabled devices',
  DATA_CENTER:
    'View the average latency to each data center and update the data center the device connects to.',
  FORWARD_NUM: 'Enables call forwarding on the port to the number entered. ',
  MONITOR:
    'If Port Alerts is enabled on Options tab, will enable this port to send alerts if it goes offline',
  OUT_NUM_OVER:
    'Allows an Administrator to override the outbound number being called on that port and forces the port to call a dedicated number',
  PORT_ENABLE:
    'Allows users to enable/Disable specific ports of an EPIK Edge Device. If Disabled, services will stop working on the disabled port, including voltage and dialtone. Note: Doing so can trigger alarm panel notifications, which can result in Truck roll to site if note in test mode.',
  E1_IP_TYPE: 'Sets whether Ethernet port E1 is using DHCP or Static IP address',
  E2_DHCP: 'Sets Ethernet Port E2 to provide DHCP. ',
  PORT_FORWARD: 'Allows an Administrator to setup network port forwarding rules. ',
  SIM_ACT_CHECK: 'Runs a check for SIM activation with the 4G carrier',
  MODEM_CHECK_UTILITY:
    'Runs a check to make sure the SIM cards are activated and can be swapped in a failover scenario',
  DEVICE_SWAP:
    'Moves configuration data from current EPIK Edge device to another EPIK Edge Device. To be used if a Device is being replaced with a new Serial Number',
  FORWARD_NUMBER: 'Enables call forwarding on the port to the number entered.',
  OUTBOUND_OVERRIDE:
    'Allows an Administrator to override the outbound number being called on that port and forces the port to call a dedicated number',
  APR_COMPANION:
    'If there are two Fire Life Safety ports on the device, this feature allows you to disable the companion port so the alarm test only goes out one path and does not fail over to the secondary path.',
  DEMO_BOX: 'Disabled Port Activation requirements and Integration',
  ADV_MODEM_CONFIG:
    'This will set TX/RX to -5/-5 on the port and sets Silence Detect to Low under Port Configuration settings.',
  BOX_REGISTRAR_CHANGE: 'Configure Box to Registar with New Registration Servers',
  DC_AUTO_SWITCH:
    'When a DC goes down, auto select other DC with next best latency',
  ACTIVE_CARRIER: 'Displays the active carrier',
  APN_MANAGEMENT: 'You can set carrier APNs',
  Band_MANAGEMENT: 'Enables remote administration of a connected USB or IP endpoint',
  LEADING9: 'Automatically removes the leading 9 from the dial plan to get an outside line',
  SEND_TONE: 'Sends an audible 60 second locator tone to device',
  INTERNATIONAL_DIALING: 'Enables the dialing rules to allow International calling.',
  DISABLE_E3: 'This disables the Ethernet connection on the last EPI in the device, thus rendering E3 unable to be connected to.',
  DBCA_ALERT: 'Direct box contact alert.',
  EPI_TIMEZONE: 'This timezone is only for EPIs',
};
export const DEVICE_LOCK_BY_SOMEONE = 'Device is currently locked for use by another User'
export const PENDING_FAX_AVAILABLE = "Port configuration is temporarily blocked because Fax service is in progress."
export const ETH3_WARNING_TEXT = "The EPI will need to be rebooted. This will cause a momentary disruption of service for approximately 3 minutes. "
export const FAILOVER_COMMANDS = ['install_failover','start_failover','restart_failover','failover_status','disable_failover','enable_failover','stop_failover','review_failover_log']